import React from "react";
import {Button, Card, Modal,Select, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from "react-redux";
import { fetchOrders,updateDeliveryStatus } from "appRedux/actions/Orders";

const FormItem = Form.Item


class SelectUpdate extends React.Component {
 // constructor(props) {
    //super(props);
    state = {
      delivery_status:this.props.recording.delivery_status,
      order_id:this.props.recording.id
    }
    //}
    componentDidMount () {
      this.props.fetchOrders(this.props.dataState)
    }
   

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La orden se ha actualizado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al actualizar el estado de la orden.',
      });
    }
  };

  onChangeC = (value) => {
      this.setState({
        delivery_status:value
      })
      console.log(this.state.order_id+" "+this.state.delivery_status);
      console.log('actual status',value[0]);
      this.props.updateDeliveryStatus(this.state.order_id,value[0]);
    this.onNotification('success');

   this.props.fetchOrders(this.props.dataState)
  }


  color=()=> {
    //console.log(this.state.delivery_status[0])
    if(this.state.delivery_status==0){
      return (
      
        <div style={{backgroundColor:'#FFCC00', width:'10px',height:'10px',borderRadius: '10px'}}>
  
        </div>
      );
    }else{
      if(this.state.delivery_status==1){
        return (
      
          <div style={{backgroundColor:'blue', width:'10px',height:'10px',borderRadius: '10px'}}>
             
          </div>
        );
      }else{
        if(this.state.delivery_status==2){
          return (
      
            <div style={{backgroundColor:'green', width:'10px',height:'10px',borderRadius: '10px'}}>
                
            </div>
          );
        }else{
          return (
      
            <div style={{backgroundColor:'red', width:'10px',height:'10px',borderRadius: '10px'}}>
                
            </div>
          );
        }
      }
    }
 
  }
  render() {

    const options = [
      {
          key: '0',
        value: '0',
        label: 'Pendiente',
     
      },
      {   key: '1',
        value: '1',
        label: 'En curso',
   
      },
      {   key: '2',
        value: '2',
        label: 'Completado',
       
      },
      {   key: '3',
        value: '3',
        label: 'Cancelada',
        
      },
    ]



    return (
      <Form>
   
      <div id="colorball" style={{position: 'relative',top: '24px',right: '18px'}}>
      {this.color(this.props.recording.delivery_status)}
      </div>

      <Col lg={12} md={12} sm={12} xs={12}>
      <FormItem
      
        labelCol={{xs: 12, sm: 12, lg: 12, md: 12}}
  
      >
        <Cascader
          defaultValue={[
            `${this.props.recording.delivery_status}`,
           
          ]}
          options={options}
          onChange={this.onChangeC}
    /*      onChange={() => {
        
            this.props.updateStatusOrder(this.props.recording.id, this.order_status );
            this.onNotification('success');
          }}*/
          placeholder="Por favor selecciona"
        />
      </FormItem>
    </Col>
    </Form>
               


    /*  <div>
        <Button type="danger" onClick={this.showModal}><i className="icon icon-trash"/></Button>
        <Modal
          okText = "Borrar"
          cancelText = "Salir"
            title="Borrar"
            visible={this.state.visible}
            onOk={() => {
              //console.log(this.props.recording.id);
              this.props.deleteOrder(this.props.recording.id, () => { this.props.fetchOrders( ); });
              this.onNotification('success');
            }}
            onCancel={() => {
              this.props.fetchOrders( );
              this.setState({visible: false});
            }}
          >
          <p>Está seguro del eliminar la orden de {this.props.recording.name}?</p>
        </Modal>
      </div>*/
    );
  }
}


function mapStateToProps({products}) {
  return {
    products
  }
}
export default connect(mapStateToProps, {fetchOrders,updateDeliveryStatus} )(SelectUpdate);


// WEBPACK FOOTER //
// ./src/routes/main/Orders/SelectUpdateStatus.js